<app-header [ngClass]="{'md:sticky md:top-0 md:z-40': this.headerService.type() === 'minimal'}"/>
<main>
  <router-outlet/>
</main>
<app-footer/>
